// @flow

export const getIdealCanvasDimensions = (image: {
  width: number,
  height: number,
}) => {
  const toolbarHeight = 60;

  const viewport = {
    width: window.innerWidth * 0.9,
    height: (window.innerHeight - toolbarHeight) * 0.9,
  };

  if (image.width < viewport.width && image.height < viewport.height) {
    return image;
  }

  const imageRatio = image.width / image.height;
  const vpRatio = viewport.width / viewport.height;

  if (vpRatio > imageRatio) {
    return {
      height: viewport.height,
      width: image.width * (viewport.height / image.height),
    };
  } else {
    return {
      width: viewport.width,
      height: image.height * (viewport.width / image.width),
    };
  }
};

export const onLoadImage = (image: HTMLImageElement) =>
  new Promise((resolve, reject) => {
    image.onload = () => resolve(image);
    image.onerror = reject;
  });

export const throttle = function (fn: () => any, delay: number) {
  let throttle = false;
  return () => {
    if (throttle) {
      return;
    }
    throttle = setTimeout(function () {
      fn.apply(this, arguments);
      throttle = false;
    }, delay);
    fn.apply(this, arguments);
  };
};

export const getImageExtension = (url: string): string => {
  const urlObj = new URL(url);
  const path = urlObj.pathname;
  return path.split('.').pop().toLowerCase().replace('jpg', 'jpeg');
};
